import React from 'react';
import {Link, Redirect} from "react-router-dom";

// function GoToHash(e){
//     // e.preventDefault();
//     console.log("got to hash has been clicked")
//      return <Redirect to={'/board/userguide#safetypromise'}></Redirect>
// }

export const BRBizInitialTourDataSharing = {
    url: `/board/BreachRisk/Business/Share/Current`,
    type: `tutorial`,
    user: {
        first_login: true,
    },
    entity: {
        verified_ownership: true,
        hasScores: null,
    },
    openingModal: {
        icon: null,
        heading: "Celebrate Your Security",
        description: <div className={"text-center"}>
            <p>
                Sharing your report with qualified companies allows you to prove your company's security.
            </p>
            <p>
                Whether you're sharing your report with clients, partners, or investors, you can manage all those relationships on this page.
            </p>

        </div>
    },
    tourSteps:{
        1:{
            step: 1,
            position: "top-right",
            title: "Inbound Requests for Your Report",
            content: "If any companies have requested your report and you have not approved or rejected them, you will find those requests in this table.",
            scrollToElement: document.querySelector("#tourStopHeader"),
            anchorEl: "#tourReportRequestTable",
            element: null,
            last: false,
        },
        2:{
            step: 2,
            title: "Approval",
            content: "To approve a request for your report, toggle the switch in this column. You can de-activate or rescind approval a request at any time.",
            scrollToElement: null,
            anchorEl: "#tourApprovalHeader",
            element: document.getElementsByClassName('tourApprovalCol'),
            last: false,
        },
        3:{
            step: 3,
            title: "Active BreachRisk™ Report Shares",
            content: "Find existing requests that you have already approved here. These companies will have access to your report until you rescind access.",
            scrollToElement: null,
            placement: "top-start",
            anchorEl: "#tourActiveShareTable",
            element: document.getElementsByClassName('highlightAddITElementButton'),
            last: false,
        },
        4:{
            step: 4,
            title: "Deactivate A Request",
            content: "If you'd like to discontinue sharing your report with a company, toggle their access here.",
            scrollToElement: null,
            anchorEl: "#tourActiveHeader",
            element: document.getElementsByClassName('tourActiveCol'),
            last: false,
        },
        5:{
            step: 5,
            title: "Share Your Report",
            content: <>
                <p>
                    If you'd like to share your report with a company that hasn't made a request, use this form. You will need the name, email address, and company name of the party you'd like to send the report to ready.
                </p>
                <p>
                    If they aren't currently using BreachRisk™, they will be sent an email inviting them to register and view your report.
                </p>
            </>,
            scrollToElement: null,
            anchorEl: "#tourReportShareInvitation",
            element: document.getElementsByClassName('tourShareInvitationButton'),
            last: false,
        },
        6:{
            step: 6,
            title: "Archive of All Sharing Requests",
            content: "Find the history of requests and share in this section including all past, inactive, and unapproved requests.",
            scrollToElement: null,
            anchorEl: "#tourPastShareTable",
            element: null,
            last: true,
        },
    },
    style: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        // width: 400,
        // height: 250,
        background: 'white',
        borderRadius: "10px",
        // border: '1px solid #000',
        boxShadow: 24,
        p: 4,
        // zIndex: 1502,
    }
}